import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { FetchCatchupPlaybackContextArgs, fetchCatchupPlaybackContext } from './queryFunctions';

export function fetchCatchupPlaybackContextQuery({
  adapterCodec,
  adapterDrm,
  adapterQuality,
  assetId,
  streamerType,
}: FetchCatchupPlaybackContextArgs) {
  return queryClient.fetchQuery({
    queryKey: queryKeys.playbackContext(adapterCodec, adapterDrm, adapterQuality, assetId, streamerType),
    queryFn: () =>
      fetchCatchupPlaybackContext({
        adapterCodec,
        adapterDrm,
        adapterQuality,
        assetId,
        streamerType,
      }),
    gcTime: 0,
    staleTime: 0,
  });
}
